import { render } from "./tradeConvert.vue?vue&type=template&id=6968735f&scoped=true"
import script from "./tradeConvert.vue?vue&type=script&lang=js"
export * from "./tradeConvert.vue?vue&type=script&lang=js"

import "./tradeConvert.vue?vue&type=style&index=0&id=6968735f&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6968735f"]])

export default __exports__